import { Journey } from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  MedallionStatus,
  Threshold
} from '../../models/status-tracker/api/api-status-tracker.interfaces';
import { TYPE } from '../../models/status-tracker/status-tracker.constants';
import { Tracker } from '../../models/status-tracker/status-tracker.interfaces';
import { decimalSeparator } from '../../services/utils/validators/structures/adapter.utils';

export const getJourney = (
  mqdThreshold: Threshold | undefined,
  aem: Tracker,
  futureTier: string,
  pending: number
): Journey => {
  const balance = getBalance(mqdThreshold?.remainderAmt);
  const futureTierDesc = getTierName(futureTier, aem);

  return getJourneyObject(
    aem,
    displayReached(futureTier) ? `${futureTierDesc} ${aem.reachedLabel}` : '',
    pending
      ? `${TYPE.CURRENCY_SYMBOL}${decimalSeparator(pending)} ${aem.mqdLabel} ${
          aem.pendingLabel
        }`
      : '',
    !displayReached(futureTier)
      ? [
          `${TYPE.CURRENCY_SYMBOL}${balance} ${aem.mqdLabel} ${aem.toLabel} ${futureTierDesc}`
        ]
      : []
  );
};

const displayReached = (tier: string) => {
  return tier === TYPE.NOT_APPLICABLE;
};

const getJourneyObject = (
  aem: Tracker,
  reached: string,
  pending: string,
  qualifier: string[]
): Journey => {
  return {
    pending,
    info: aem.tooltipInfo,
    reached,
    qualifier,
    more: '',
    ariaLabels: { pending: 'Pending info' } // TODO : Arialabel will be updated in AEM for nov release
  };
};

const getBalance = (balance: number | undefined): string => {
  return balance ? decimalSeparator(balance) : TYPE.MIN_LIMIT;
};

export const getNextTierName = (
  currentMedallionStatus: MedallionStatus[]
): string => {
  const code = currentMedallionStatus.find(
    (status) => status.trackingToTierLevelCode
  )?.trackingToTierLevelCode as string;

  return code;
};

const getTierName = (tier: string, aem: Tracker): string => {
  tier = tier === TYPE.NOT_APPLICABLE ? TYPE.DIAMOND_MEDALLION : tier;
  return (
    aem.medallionDetails.find((detail) => detail.medallionId === tier)
      ?.medallionDesc || ''
  );
};
